import GSAP from "gsap";

export const startOpening = (root) => {
  if (!root) return null;
  if (root.__rockyOpening) return root.__rockyOpening;
  const loader = root.querySelector(".LoaderLocal");
  const letters = root.querySelectorAll(".LoaderLocal__letters span");
  const enter = root.querySelector(".EnterButton");
  const percent = root.querySelector(".EnterButton__percent");
  if (!loader || !enter || !percent) return null;

  const state = { ready: false, viewReady: false, claimed: false, requested: false, startedAt: performance.now() };
  root.__rockyOpening = state;
  const rememberEnter = () => { if (!state.claimed) state.requested = true; };
  enter.addEventListener("click", rememberEnter);
  state.release = () => enter.removeEventListener("click", rememberEnter);

  GSAP.set(loader, { autoAlpha: 1 });
  GSAP.set(enter, { pointerEvents: "none" });
  GSAP.set(percent, { yPercent: 0 });
  GSAP.set(root.querySelector(".EnterButton__copy"), { yPercent: -130 });
  root.removeAttribute("data-rocky-pending");
  GSAP.timeline({ defaults: { ease: "expo.out" } })
    .fromTo(letters, { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.9, stagger: 0.012 })
    .to(letters, { autoAlpha: 0.16, duration: 0.95, stagger: 0.006, ease: "expo.inOut" }, 0.78)
    .fromTo(root.querySelector(".LoaderLocal__rings"), { autoAlpha: 0, scale: 0.5, rotate: -28 }, { autoAlpha: 1, scale: 1, rotate: 0, duration: 1.25 }, 0.8)
    .fromTo(root.querySelector(".LoaderLocal__stamp"), { autoAlpha: 0, scale: 0.7, rotate: 12 }, { autoAlpha: 0.07, scale: 1, rotate: -4, duration: 1.05 }, 0.95)
    .fromTo(enter, { autoAlpha: 0, scale: 0.6 }, { autoAlpha: 1, scale: 1, duration: 0.85 }, 1.08);

  const progress = { value: 0 };
  GSAP.to(progress, {
    value: 100,
    duration: 1.65,
    ease: "power2.out",
    onUpdate: () => { percent.textContent = Math.round(progress.value); },
    onComplete: () => {
      state.ready = true;
      enter.classList.add("is-ready");
      GSAP.set(enter, { pointerEvents: "all" });
      if (state.onReady) state.onReady();
    },
  });
  state.animation = GSAP.fromTo(root.closest("[data-key]") || root, { opacity: 0 }, {
    opacity: 1, duration: 0.8, ease: "expo.out",
    onComplete: () => {
      state.viewReady = true;
      if (state.onViewReady) state.onViewReady();
    },
  });
  return state;
};
